
import { addDoc } from '../libs/firestore';

function postFeedback(email: string, feedback: string, url: string) {
    return addDoc('feedback', { email, feedback, url });
}

export { postFeedback }
